<template>
  <div class="modal" :class="{ modal_active: isModalVisible }">
    <div class="modal__container" :class="{ modal__container_active: isModalVisible }">
      <p class="modal__container_message">
        Похоже возникли трудности с определением местоположения, пожалуйста введите кодовую фразу чтобы пройти точку
        маршрута!
      </p>
      <input v-model="keyWord" placeholder="Введите кодовую фразу" class="modal__container_input" />
      <button @click="handleDismissModal" class="modal__container-button_success">
        Отправить
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalKeyWord",
  props: {
    isModalVisible: Boolean,
    passPointByKeyWord: Function
  },
  data: () => ({
    keyWord: "",
  }),
  watch: {
    isModalVisible: function (value) {
      return value;
    },
  },
  methods: {
    handleDismissModal() {
      this.passPointByKeyWord(this.keyWord);
      this.keyWord = "";
      this.$emit("modal-dismissed");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../styles/variables";

.modal {
  position: relative;
  z-index: 20;

  &_active {
    &::before {
      content: "hello";
      display: flex;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-size: cover;
      background-color: $color-black;
      opacity: 0.5;
    }
  }

  &__container {
    display: none;
    width: 100%;
    z-index: 21;

    &_active {
      display: flex;
      position: fixed;
      top: 30%;
      gap: 20px;
      left: 10%;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background-color: $color-very-light-gray;
      word-wrap: break-word;
      border-radius: 10px;
      padding: 20px;
      width: 80%;
      min-width: 100px;
      height: auto;
      min-height: 200px;
    }

    &_message {
      line-height: 20px;
      text-align: center;
      font-size: 16px;
      color: "black";
      margin: auto;
      font-weight: 700;
    }

    &_input {
      width: 100%;
      padding: 12px 20px;
      font-size: 16px;
      color: #2b2b2b;
      background-color: #fff;
      border: 1px solid #e0e0e0;
      border-radius: 30px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
      transition: border-color 0.2s ease, box-shadow 0.2s ease;

      &::placeholder {
        color: #aaa;
      }

      &:focus {
        outline: none;
        border-color: #59c36a;
        box-shadow: 0 0 0 3px rgba(89, 195, 106, 0.3);
      }
    }

    &-button {
      &_success {
        font-size: 13px;
        color: $color-positive;
        font-weight: 700;
        background-color: $color-white;
        border-radius: 20px;
        width: 100%;
        height: 100%;
        max-width: 123px;
        min-height: 46px;
        max-height: 46px;
        filter: drop-shadow(0 4px 14px rgba($color-blue-shadow, 0.1));
      }
    }
  }
}
</style>
